"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var social_groups_api_1 = require("@wix/social-groups-api");
var PubSubEventTypes_1 = require("../pubSub/PubSubEventTypes");
var lodash_1 = require("lodash");
var loggers_1 = require("@wix/social-groups-common/dist/src/loggers");
var Controller_1 = require("../Controller");
var utils_1 = require("../../seo/utils");
var routeParams_1 = require("../routeParams");
var controllers_1 = require("@wix/social-groups-common/dist/src/controllers");
var GroupSEOItemType_1 = require("../../seo/GroupSEOItemType");
var MembershipAnswers_1 = require("@wix/social-groups-api/dist/src/model/MembershipAnswers");
exports.MEMBERS_APP_DEF_ID = '14cc59bc-f0b7-15b8-e1c7-89ce41d0e0c9';
var SELECT_ALL_MEMBER_ID = 'select-all';
var MembersController = /** @class */ (function (_super) {
    tslib_1.__extends(MembersController, _super);
    function MembersController(controllerConfig, group) {
        var _this = _super.call(this, controllerConfig, group.groupId) || this;
        _this.group = group;
        // for showing progress for members update we using membersToUpdate set, where we store ids of updating members
        // in case we add members by Select All option we add to the Set special id = SELECT_ALL_MEMBER_ID.
        _this.membersToUpdate = new Set();
        _this.currentMember = social_groups_api_1.Anonymous;
        _this.siteMembersMap = {};
        _this.setMembers = function (group) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, members, currentMember, currentSiteMember, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getMembers(group)];
                    case 1:
                        _a = _b.sent(), members = _a.members, currentMember = _a.currentMember, currentSiteMember = _a.currentSiteMember;
                        this.setProps({
                            members: members,
                            siteMembersMap: this.siteMembersMap,
                            currentMember: currentMember,
                            currentSiteMember: currentSiteMember,
                            isLoggedIn: this.isUserLoggedIn(),
                            membersUpdate: tslib_1.__spread(this.membersToUpdate),
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        loggers_1.ConsoleLogger.log(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.filterMembers = function (group, searchQuery) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var filteredMembersResponse, filteredMembers, query, e_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        filteredMembers = [];
                        query = {
                            groupId: group.groupId,
                            query: {
                                filter: {
                                    nickname: {
                                        $contains: searchQuery,
                                    },
                                },
                            },
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 6, 7, 8]);
                        if (!social_groups_api_1.canFetchAllMembers(group)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.api.queryAllMembers(query)];
                    case 2:
                        filteredMembersResponse = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this.api.queryGroupMembers(query)];
                    case 4:
                        filteredMembersResponse = _a.sent();
                        _a.label = 5;
                    case 5:
                        filteredMembers = filteredMembersResponse.data.members || [];
                        return [3 /*break*/, 8];
                    case 6:
                        e_2 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_2);
                        return [3 /*break*/, 8];
                    case 7:
                        this.setProps({
                            membersQueryResponse: {
                                query: searchQuery,
                                members: filteredMembers.slice(0, Math.min(filteredMembers.length, 5)),
                            },
                        });
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        _this.addAllNonGroupMembers = function (group, excludedSiteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var count, e_3;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        this.membersToUpdate.add(SELECT_ALL_MEMBER_ID);
                        this.controllerConfig.setProps({
                            membersUpdate: tslib_1.__spread(this.membersToUpdate),
                        });
                        count = this.nonGroupMembersCount - excludedSiteMemberIds.length;
                        return [4 /*yield*/, this.api.addAllNonGroupMembersToGroup(group.groupId, excludedSiteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(group)];
                    case 2:
                        _a.sent();
                        this.showMembersAddedToast(count);
                        return [3 /*break*/, 5];
                    case 3:
                        e_3 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_3);
                        return [3 /*break*/, 5];
                    case 4:
                        this.membersToUpdate.delete(SELECT_ALL_MEMBER_ID);
                        if (!this.membersToUpdate.size) {
                            this.controllerConfig.setProps({
                                membersUpdate: tslib_1.__spread(this.membersToUpdate),
                            });
                        }
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.addMembers = function (group, memberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_4;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        memberIds.forEach(function (memberId) {
                            _this.membersToUpdate.add(memberId);
                        });
                        this.controllerConfig.setProps({
                            membersUpdate: tslib_1.__spread(this.membersToUpdate),
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 8]);
                        return [4 /*yield*/, this.api.addToGroup(group.groupId, memberIds)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(group)];
                    case 3:
                        _a.sent();
                        this.showMembersAddedToast(memberIds.length);
                        return [3 /*break*/, 8];
                    case 4:
                        e_4 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_4);
                        return [3 /*break*/, 8];
                    case 5:
                        this.membersToUpdate.clear();
                        if (!!this.membersToUpdate.size) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.setNonGroupMembers()];
                    case 6:
                        _a.sent();
                        this.publishGroupUpdate(group.groupId);
                        _a.label = 7;
                    case 7: return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        }); };
        _this.openCurrentUserProfile = function () {
            _this.getLocation().to('/account/profile');
        };
        _this.openUserProfile = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var membersApi, e_5;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.controllerConfig.wixCodeApi.site.getPublicAPI(exports.MEMBERS_APP_DEF_ID)];
                    case 1:
                        membersApi = _a.sent();
                        membersApi.navigateToMember({ memberId: siteMemberId });
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        console.error('Navigate to profile: FAIL');
                        this.getLocation().to("/profile/" + siteMemberId);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.onDidUpdateGroup = function (_a) {
            var data = _a.data;
            try {
                _this.group = JSON.parse(data);
                if (_this.membersToUpdate.size) {
                    _this.membersToUpdate.clear();
                }
                // relationship with group or permittedToInvite can be changed - so need to fetch members one more time
                // (due to those params we decide can we fetch all site members or only group members)
                return _this.setMembers(_this.group);
            }
            catch (e) {
                console.log('Failed in DID_UPDATE_GROUP_EVENT');
            }
        };
        _this.removeMembersFromGroup = function (groupId, siteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_6;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        return [4 /*yield*/, this.api.removeFromGroup(groupId, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(this.group)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_6 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_6);
                        return [3 /*break*/, 5];
                    case 4:
                        this.publishGroupUpdate(groupId);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.changeMemberRoleInGroup = function (groupId, siteMemberId, role) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_7;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, 4, 5]);
                        //TODO: optimistic update?
                        return [4 /*yield*/, this.api.setMemberRole(groupId, siteMemberId, role)];
                    case 1:
                        //TODO: optimistic update?
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(this.group)];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        e_7 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_7);
                        return [3 /*break*/, 5];
                    case 4:
                        this.publishGroupUpdate(groupId);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        _this.getNewMembers = function (groupId, startDate) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var newMembers, data, e_8;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.countNewMembers(groupId, {
                                filter: {
                                    dateUpdated: { $gte: startDate.toISOString() },
                                },
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        newMembers = data.newMembers;
                        return [3 /*break*/, 3];
                    case 2:
                        e_8 = _a.sent();
                        console.error(e_8);
                        newMembers = 0;
                        return [3 /*break*/, 3];
                    case 3:
                        this.setProps({ newMembers: newMembers });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.makeProfilePublic = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var groupId, member, e_9;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this.membersToUpdate.add(siteMemberId);
                        this.setProps({ membersUpdate: tslib_1.__spread(this.membersToUpdate) });
                        return [4 /*yield*/, this.getGroupId()];
                    case 1:
                        groupId = _a.sent();
                        this.publishGroupWillUpdate(groupId);
                        return [4 /*yield*/, this.api.updateSiteMemberPrivacy(siteMemberId, social_groups_api_1.SiteMemberPrivacyStatus.PUBLIC)];
                    case 2:
                        member = (_a.sent()).data.member;
                        this.currentMember = member;
                        this.setProps({ currentSiteMember: member });
                        this.publishContextTokenUpdate(groupId);
                        this.publishGroupUpdate(groupId);
                        return [3 /*break*/, 4];
                    case 3:
                        e_9 = _a.sent();
                        console.error('Update site member profile: FAIL', e_9);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.getPendingMembers = function (groupId, limit, cursor) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, e_10;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.listPendingMembers(groupId, limit, cursor)];
                    case 1:
                        data = (_a.sent()).data;
                        //TODO: cursor tokens
                        this.setProps({
                            pendingMembers: data,
                        });
                        return [3 /*break*/, 3];
                    case 2:
                        e_10 = _a.sent();
                        console.error('List Pending Members: FAIL');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.approvePendingMembersRequests = function (groupId, siteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_11;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.approveGroupMembershipRequests(groupId, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([
                                this.getPendingMembers(groupId),
                                this.publishGroupUpdate(groupId),
                            ])];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_11 = _a.sent();
                        console.error('Approve Pending Members: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.followMember = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_12;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.followMember(siteMemberId)];
                    case 1:
                        _a.sent();
                        this.followingMembers.push(siteMemberId);
                        this.setProps({ followingMembers: this.followingMembers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_12 = _a.sent();
                        console.error('Follow members: FAIL', e_12);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.unfollowMember = function (siteMemberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_13;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.unfollowMember(siteMemberId)];
                    case 1:
                        _a.sent();
                        this.followingMembers.splice(this.followingMembers.indexOf(siteMemberId), 1);
                        this.setProps({ followingMembers: this.followingMembers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_13 = _a.sent();
                        console.error('Unfollow members: FAIL', e_13);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.getFollowingMembers = function (userId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var userIds, e_14;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getFollowingMembers(userId)];
                    case 1:
                        userIds = (_a.sent()).data.userIds;
                        this.followingMembers = userIds;
                        this.setProps({ followingMembers: this.followingMembers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_14 = _a.sent();
                        console.log('Get following members: FAIL');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.rejectPendingMembersRequests = function (groupId, siteMemberIds) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_15;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this.api.rejectGroupMembershipRequests(groupId, siteMemberIds)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, Promise.all([
                                this.getPendingMembers(groupId),
                                this.publishGroupUpdate(groupId),
                            ])];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        e_15 = _a.sent();
                        console.error('Reject Pending Members: FAIL');
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        /**
         *
         * @param {string[]} ids
         * @return {Promise<void>}
         */
        _this.onFeedAuthorsIds = function (_a) {
            var ids = _a.data;
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _ids, q, _b, promises, _c, groupMembers, nonGroupMembers;
                var _this = this;
                return tslib_1.__generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            if (!ids) {
                                return [2 /*return*/];
                            }
                            _ids = ids.filter(function (id) { return !_this.siteMembersMap[id]; });
                            if (!_ids.length) {
                                return [2 /*return*/];
                            }
                            q = new social_groups_api_1.MembersRequestBuilder().filterWithIds(_ids).build();
                            _b = q;
                            return [4 /*yield*/, this.getGroupId()];
                        case 1:
                            _b.groupId = _d.sent();
                            promises = [this.queryGroupMembers(q)];
                            if (this.isUserLoggedIn()) {
                                promises.push(this.queryNonGroupMembers(q));
                            }
                            return [4 /*yield*/, Promise.all(promises)];
                        case 2:
                            _c = tslib_1.__read.apply(void 0, [_d.sent(), 2]), groupMembers = _c[0], nonGroupMembers = _c[1];
                            this.setMembersMap((nonGroupMembers || []).concat(groupMembers));
                            this.setProps({ siteMembersMap: this.siteMembersMap });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.setNonGroupMembers = function (queryReq) {
            if (queryReq === void 0) { queryReq = { query: {} }; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var groupId, _a, siteMembers;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getGroupId()];
                        case 1:
                            groupId = _b.sent();
                            queryReq.groupId = groupId;
                            return [4 /*yield*/, Promise.all([
                                    this.queryNonGroupMembers(queryReq),
                                    this.setNonGroupMembersCount(groupId),
                                ])];
                        case 2:
                            _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), siteMembers = _a[0];
                            this.setMembersMap(siteMembers);
                            this.setProps({
                                siteMembersMap: this.siteMembersMap,
                                siteMembers: siteMembers,
                                nonGroupMembersCount: this.nonGroupMembersCount,
                                membersUpdate: tslib_1.__spread(this.membersToUpdate),
                            });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.listMembershipQuestionAnswers = function (groupId, siteMemberIds, itemsFilter) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var data, questionsAnswers, e_16;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.listMembershipQuestionAnswers(groupId, siteMemberIds, itemsFilter)];
                    case 1:
                        data = (_a.sent()).data;
                        questionsAnswers = MembershipAnswers_1.MembershipAnswers.fromResponse(data);
                        this.setProps({ questionsAnswers: questionsAnswers });
                        return [3 /*break*/, 3];
                    case 2:
                        e_16 = _a.sent();
                        console.log('Error in MembersController.listMembershipQuestionAnswers');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        }); };
        _this.setApi(_this.getSiteToken());
        _this.setSubscriptions();
        _this.onUserLogin(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var e_17;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setApi(this.getSiteToken());
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this.setCurrentMember()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.setMembers(group)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        e_17 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_17);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
        return _this;
    }
    /**
     *  Scenarios:
     *  1. Logged in
     *    1.A. Profile Public
     *      1.A.1. - public group
     *        1.A.1.a - member
     *        1.A.1.b - not a member
     *      1.A.2. - private group
     *        1.A.2.a - member
     *        1.A.2.b - not a member
     *    1.B. Profile Private
     *  2. Not logged
     *
     * @param {wrapper.wix.social.groups.api.v1.GroupResponse} group
     * @return {Promise<{currentMember: wrapper.wix.social.groups.api.v1.GroupMemberResponse; nonGroupMembersCount: number; members: wrapper.wix.social.groups.api.v1.GroupMemberResponse[]; currentSiteMember: SiteMember; siteMembersMap: Dictionary<unknown>; siteMembers: wrapper.wix.social.groups.api.v1.GroupMemberResponse[]}>}
     */
    MembersController.prototype.getMembers = function (group) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var promises, _a, members, currentSiteMember;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!social_groups_api_1.canSeeMembers(group)) {
                            return [2 /*return*/];
                        }
                        promises = [this.fetchGroupMembers(group.groupId)];
                        if (this.isUserLoggedIn()) {
                            promises.push(this.getCurrentSiteMember(), this.setCurrentMember());
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 2]), members = _a[0], currentSiteMember = _a[1];
                        this.setMembersMap(members);
                        return [2 /*return*/, {
                                members: members,
                                currentMember: this.currentMember,
                                currentSiteMember: currentSiteMember,
                            }];
                }
            });
        });
    };
    MembersController.prototype.setMembersMap = function (siteMembers) {
        var siteMembersMap = lodash_1.keyBy(siteMembers, 'siteMemberId');
        Object.assign(this.siteMembersMap, siteMembersMap);
    };
    MembersController.prototype.getNonGroupMembersCount = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var count, e_18;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.countNonGroupMembers(groupId)];
                    case 1:
                        count = (_a.sent()).data.count;
                        return [2 /*return*/, count];
                    case 2:
                        e_18 = _a.sent();
                        loggers_1.ConsoleLogger.log('Get non group members count: FAIL', e_18);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get current site member (basically to know if the member has a private profile)
     * @return {Promise<SiteMember>}
     */
    MembersController.prototype.getCurrentSiteMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var member, e_19;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isUserLoggedIn()) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.getCurrentSiteMember()];
                    case 2:
                        member = (_a.sent()).data.member;
                        return [2 /*return*/, member];
                    case 3:
                        e_19 = _a.sent();
                        console.error('Get current site member profile: FAIL', e_19);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    MembersController.prototype.queryGroupMembers = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var members, e_20;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.queryGroupMembers(query)];
                    case 1:
                        members = (_a.sent()).data.members;
                        return [2 /*return*/, members];
                    case 2:
                        e_20 = _a.sent();
                        loggers_1.ConsoleLogger.log('FAIL to fetch non group members', e_20);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, []];
                }
            });
        });
    };
    MembersController.prototype.queryNonGroupMembers = function (queryReq) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var members, e_21;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        //TODO: get BE guys to implement paging for this request and remove this code
                        if (queryReq.query && queryReq.query.paging) {
                            return [2 /*return*/, this.getLimitedMembers(queryReq)];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.queryNonGroupMembers(queryReq)];
                    case 2:
                        members = (_a.sent()).data.members;
                        return [2 /*return*/, members];
                    case 3:
                        e_21 = _a.sent();
                        loggers_1.ConsoleLogger.log('FAIL to fetch non group members', e_21);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    //TODO: get BE guys to implement paging for this request and remove this code
    MembersController.prototype.getLimitedMembers = function (queryReq) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, limit, offset, members, start, end, e_22;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        _a = queryReq.query.paging, limit = _a.limit, offset = _a.offset;
                        delete queryReq.query.paging;
                        return [4 /*yield*/, this.queryNonGroupMembers(queryReq)];
                    case 1:
                        members = _b.sent();
                        start = offset || 0;
                        end = Math.min(limit || members.length, members.length);
                        return [2 /*return*/, members.slice(start, end)];
                    case 2:
                        e_22 = _b.sent();
                        loggers_1.ConsoleLogger.log('FAIL to fetch non group members', e_22);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MembersController.prototype.fetchAllMembers = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var limit, data, e_23;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        limit = 1000;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api.listAllMembers(groupId, {
                                limit: limit,
                            })];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.members];
                    case 3:
                        e_23 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_23);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, []];
                }
            });
        });
    };
    MembersController.prototype.fetchGroupMembers = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_24;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.listGroupMembers(groupId, {
                                includeDeleted: true,
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.members];
                    case 2:
                        e_24 = _a.sent();
                        loggers_1.ConsoleLogger.log(e_24);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, []];
                }
            });
        });
    };
    MembersController.prototype.publishGroupUpdate = function (groupId) {
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.UPDATE_GROUP_EVENT, groupId, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.publishGroupWillUpdate = function (groupId) {
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.WILL_UPDATE_GROUP_EVENT, groupId, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.publishContextTokenUpdate = function (groupId) {
        try {
            this.controllerConfig.platformAPIs.pubSub.publish(PubSubEventTypes_1.PubSubEventTypes.UPDATE_CONTEXT_TOKENS_EVENT, groupId, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.showMembersAddedToast = function (membersAddedCount) {
        try {
            controllers_1.AppToastsController.publish(this.controllerConfig.platformAPIs.pubSub, {
                type: social_groups_api_1.AppToastTypes.MEMBERS_ADDED,
                options: {
                    count: membersAddedCount,
                },
            });
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.setApi = function (siteToken) {
        this.api = new social_groups_api_1.MembersApi(siteToken, this.getApiBaseUrl());
    };
    MembersController.prototype.setSubscriptions = function () {
        var _this = this;
        try {
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.UPDATE_MEMBERS_EVENT, function () {
                try {
                    _this.controllerConfig.setProps({
                        membersUpdate: tslib_1.__spread(_this.membersToUpdate, [
                            _this.getCurrentUser().id,
                        ]),
                    });
                    return _this.setMembers(_this.group);
                }
                catch (e) { }
            }, false);
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.DID_UPDATE_GROUP_EVENT, this.onDidUpdateGroup, false);
            this.controllerConfig.platformAPIs.pubSub.subscribe(PubSubEventTypes_1.PubSubEventTypes.FEED_AUTHORS_IDS, this.onFeedAuthorsIds, false);
        }
        catch (e) {
            loggers_1.ConsoleLogger.log(e);
        }
    };
    MembersController.prototype.setProps = function (props) {
        this.controllerConfig.setProps(props);
    };
    MembersController.prototype.pageReady = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.setProps({
                    membersActions: {
                        addMembers: this.addMembers,
                        addAllNonGroupMembers: this.addAllNonGroupMembers,
                        approvePendingMembersRequests: this.approvePendingMembersRequests,
                        changeMemberRoleInGroup: this.changeMemberRoleInGroup,
                        filterMembers: this.filterMembers,
                        getNewMembers: this.getNewMembers,
                        getPendingMembers: this.getPendingMembers,
                        makeProfilePublic: this.makeProfilePublic,
                        openCurrentUserProfile: this.openCurrentUserProfile,
                        followMember: this.followMember,
                        unfollowMember: this.unfollowMember,
                        getFollowingMembers: this.getFollowingMembers,
                        openUserProfile: this.openUserProfile,
                        rejectPendingMembersRequests: this.rejectPendingMembersRequests,
                        removeMembersFromGroup: this.removeMembersFromGroup,
                        setMembers: this.setMembers,
                        setNonGroupMembers: this.setNonGroupMembers,
                        listMembershipQuestionAnswers: this.listMembershipQuestionAnswers,
                    },
                });
                try {
                    return [2 /*return*/, this.setMembers(this.group)];
                }
                catch (e) {
                    loggers_1.ConsoleLogger.log(e);
                }
                return [2 /*return*/];
            });
        });
    };
    MembersController.prototype.getInitialProps = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var itemType, isSEO, isMembersTab, initialProps;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        itemType = utils_1.getGroupSEOItemType(routeParams_1.groupRoute(this.controllerConfig.wixCodeApi.location));
                        isSEO = [
                            GroupSEOItemType_1.GroupSEOItemType.GROUPS_POST,
                            GroupSEOItemType_1.GroupSEOItemType.GROUPS_MEMBERS,
                            GroupSEOItemType_1.GroupSEOItemType.GROUPS_COMMENT,
                        ].includes(itemType);
                        isMembersTab = this.getLocation();
                        if (!isSEO) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getMembers(this.group)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        initialProps = {
                            currentMember: this.currentMember || social_groups_api_1.Anonymous,
                            followingMembers: [],
                            membersQueryResponse: social_groups_api_1.MembersQueryInitialResponse,
                            siteMembersMap: this.siteMembersMap,
                        };
                        return [2 /*return*/, Promise.resolve(initialProps)];
                }
            });
        });
    };
    MembersController.prototype.getCurrentMember = function (memberId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data, e_25;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.getGroupMember(this.group.groupId, memberId)];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data.member || social_groups_api_1.Anonymous];
                    case 2:
                        e_25 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, social_groups_api_1.Anonymous];
                }
            });
        });
    };
    MembersController.prototype.setCurrentMember = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var id, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        id = this.getCurrentUser().id;
                        _a = this;
                        return [4 /*yield*/, this.getCurrentMember(id)];
                    case 1:
                        _a.currentMember = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    MembersController.prototype.setNonGroupMembersCount = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.getNonGroupMembersCount(groupId)];
                    case 1:
                        _a.nonGroupMembersCount = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return MembersController;
}(Controller_1.Controller));
exports.MembersController = MembersController;
//# sourceMappingURL=MembersController.js.map